/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MaintananceLevelModel } from '../../models/maintanance-level-model';

export interface GetMaintananceLevels$Params {
}

export function GetMaintananceLevels(http: HttpClient, rootUrl: string, params?: GetMaintananceLevels$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<MaintananceLevelModel>>> {
  const rb = new RequestBuilder(rootUrl, GetMaintananceLevels.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<MaintananceLevelModel>>;
    })
  );
}

GetMaintananceLevels.PATH = '/api/Supervisor/GetMaintananceLevels';
